import React from "react";
import { StaticQuery, graphql } from "gatsby";

function WidgetContactEmail() {
  return (
    <StaticQuery
      query={graphql`
        query EmailQuerySub {
          site {
            siteMetadata {
              email
            }
          }
        }
      `}
      render={data => (
        <div className="flex mb-4 mr-6">
          <a href={'mailto:' + data.site.siteMetadata.email} className="flex no-underline text-white">
          <div className="link bg-blue py-2 px-6 h-12 rounded-full flex items-center hover:text-orange transition">

            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="17.067" height="12" viewBox="0 0 512 360">
              <path fill="currentColor" d="M331.8 201.3l-42.9 43c-17.4 17.5-48 17.8-65.8 0l-42.9-43-154 154.5C32 358.4 38.3 360 45 360h422c6.7 0 13-1.6 18.8-4.2l-154-154.5z"/>
              <path fill="currentColor" d="M467 0H45c-6.7 0-13 1.6-18.8 4.2l164.6 165.1 53.5 53.7c5.7 5.7 17.6 5.7 23.3 0l53.5-53.7L485.8 4.2C480 1.6 473.7 0 467 0zM4.8 25.2C1.8 31.2 0 37.9 0 45v270c0 7.1 1.8 13.8 4.8 19.8L159.1 180 4.8 25.2zM507.2 25.2L352.9 180l154.3 154.8c3-6 4.8-12.7 4.8-19.8V45c0-7.1-1.8-13.8-4.8-19.8z"/>
            </svg>

            <span>Skicka e-post</span>
          </div>
          </a>
        </div>
      )}
    />
  )
}

export default WidgetContactEmail;